import { currencyFormatterCommas } from '@on3/ui-lib/utils/formatters';
import clsx from 'clsx';
import { On3Avatar } from 'components/Image/On3Avatar';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { Text } from 'components/UI/Typography/Text';

import { CompactHeaderProps as ICompactHeaderProps } from './CompactHeader';
import styles from './CompactHeader.module.scss';

export const CompactCoach = ({ coachInfo }: ICompactHeaderProps) => {
  return (
    <div
      className={clsx(styles.measurementWrapper, {
        [styles.coachHeader]: true,
      })}
    >
      <div
        className={clsx({
          [styles.teamAvatar]: true,
        })}
      >
        <On3Avatar
          altText={coachInfo?.defaultAsset?.altText || 'Player Avatar'}
          className={styles.avatar}
          {...coachInfo?.defaultAsset}
          fit="cover"
          height={60}
          quality={90}
          radiusFive
          width={60}
        />
        <TeamAvatar
          className={styles.team}
          height={50}
          slug={coachInfo?.organization?.slug}
          src={coachInfo?.organization?.assetUrl}
          width={50}
        />
      </div>
      <div className={styles.playerSpecsContainer}>
        <div className={styles.coachSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Current Pos.
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {coachInfo?.primaryPosition?.name ?? '-'}
          </Text>
        </div>
        <div className={styles.coachSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Salary
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {coachInfo?.salary
              ? currencyFormatterCommas(coachInfo?.salary)
              : '-'}
          </Text>
        </div>
        <div className={styles.coachSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Age
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {coachInfo?.age ?? '-'}
          </Text>
        </div>
        <div className={styles.coachSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Alma Mater
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {coachInfo?.almaMater?.name ?? '-'} /{' '}
            {coachInfo?.almaMaterClassYear}
          </Text>
        </div>
        <div className={styles.coachSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Hometown
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {coachInfo?.homeTownName}
          </Text>
        </div>
      </div>
    </div>
  );
};
